<template>
    <basic-card style="margin-bottom: 0px;">
        <template slot="header">
            <div>
                <icon :icon="['fas', 'grip-vertical']" class="handle"></icon>
            </div>
            &nbsp;
            Widget
        </template>
        <form-wrapper>
            <form-text-input caption="Display name" v-model="value.displayName"/>
            <form-text-input caption="Description" v-model="value.description"/>
            <form-select-input caption="Widget type" :options="widgetTypeOptions" v-model="value.widgetType"/>
        </form-wrapper>
        <template v-if="selectedWidgetType != undefined">
            <h1>Options</h1>
            <form-wrapper>
                <template v-for="option in selectedWidgetType.options">
                    <form-text-input :caption="option.displayName" v-if="option.type == 'string'"
                                     v-model="value.options[option.name]"/>
                    <form-checkbox-input :caption="option.displayName" v-if="option.type == 'boolean'"
                                         v-model="value.options[option.name]"/>
                    <form-date-expression-input :caption="option.displayName" v-if="option.type == 'dateExpression'"
                                                v-model="value.options[option.name]"/>
                    <form-number-input :caption="option.displayName" v-if="option.type == 'number'"
                                       v-model="value.options[option.name]"/>
                    <form-select-input :caption="option.displayName" v-if="option.type == 'enum'"
                                       :options="option.options" v-model="value.options[option.name]"/>
                    <form-select-input :caption="option.displayName" v-if="option.type == 'account'"
                                       :options="accountOptions" v-model="value.options[option.name]"/>
                    <form-select-input :caption="option.displayName" v-if="option.type == 'exchangeRate'"
                                       :options="exchangeRateOptions" v-model="value.options[option.name]"/>
                    <form-select-input :caption="option.displayName" v-if="option.type == 'currency'"
                                       :options="currencies" v-model="value.options[option.name]"/>
                    <form-multi-select-input :caption="option.displayName" v-if="option.type == 'array-account'"
                                             :options="accountOptions" v-model="value.options[option.name]"/>
                    <form-multi-select-input :caption="option.displayName"
                                             v-if="option.type == 'array-importDefinition'"
                                             :options="importDefinitionOptions" v-model="value.options[option.name]"/>
                    <form-select-input :caption="option.displayName" v-if="option.type == 'accountQuery'"
                                       :options="accountQueryOptions" v-model="value.options[option.name]"/>
                    <form-select-input :caption="option.displayName" v-if="option.type == 'processHistoryQuery'"
                                       :options="processHistoryQueryOptions" v-model="value.options[option.name]"/>
                    <form-select-input :caption="option.displayName" v-if="option.type == 'cashflowReportDefinition'"
                                       :options="cashflowReportDefinitions" v-model="value.options[option.name]"/>

                    <form-select-input :caption="option.displayName" v-if="option.type === 'operationDefinitionId'"
                                       :options="operationDefinitions" v-model="value.options[option.name]"/>

                    <form-select-input :caption="option.displayName" v-if="option.type === 'operationDefinitionQuery'"
                                       :options="operationQueryOptions(value.options['operationDefinitionId'])"
                                       v-model="value.options[option.name]"/>


                </template>
            </form-wrapper>
            <div class="widget-actions">
                <simple-button confirmation-protected @proceed="requestDelete">
                    <icon :icon="['fal', 'trash']"/>
                </simple-button>
            </div>

        </template>
    </basic-card>
</template>

<script>
import BasicCard from "../layout/BasicCard";
import FormWrapper from "../form/FormWrapper";
import FormTextInput from "../form/FormTextInput";
import Widgets from "../../dashboard/widgets"
import FormSelectInput from "../form/FormSelectInput";
import FormDateExpressionInput from "../form/FormDateExpressionInput";
import FormNumberInput from "../form/FormNumberInput";
import { mapGetters } from "vuex";
import FormMultiSelectInput from "../form/FormMultiSelectInput";
import FormCheckboxInput from "../form/FormCheckboxInput";
import SimpleButton from "../button/SimpleButton";

export default {
    name: "EditWidgetCard",
    components: {
        SimpleButton,
        FormCheckboxInput,
        FormMultiSelectInput,
        FormNumberInput, FormDateExpressionInput, FormSelectInput, FormTextInput, FormWrapper, BasicCard
    },
    props: {
        value: Object
    },
    data() {
        return {
            widgetTypeOptions: Widgets.map(widget => ({name: widget.displayName, id: widget.name}))
        }
    },
    computed: {
        ...mapGetters({
            "accounts": "banking/accounts",
            "exchangeRates": "currencies/exchangeRates",
            "currencies": "currencies/currenciesOptions",
            accountQueries: "accountQueries/accountQueries",
            processQueries: "processQueries/processQueries",
            importDefinitions: 'importDefinitions/importDefinitions',
            cashflowReportDefinitions: "cashflowReportDefinitions/cashflowReportDefinitions",
            operationDefinitions: "operationDefinitions/operationDefinitions",
            operationQueries: "operationQueries/operationQueries",
        }),
        processHistoryQueryOptions() {

            return this.processQueries
              .map(query => ({id: query.id, name: query.name == null ? "No-name" : query.name}))
        },
        accountQueryOptions() {
            return this.accountQueries
              .filter(query => query.object == 'account')
              .map(query => ({id: query.id, name: query.name == null ? "No-name" : query.name}))
        },
        accountOptions() {
            return this.accounts.filter(acc => acc.internal).map(acc => ({name: acc.name, id: acc.id}))
        },
        importDefinitionOptions() {
            return this.importDefinitions.filter(importDef => importDef.type == "JOB").map(importDef => ({
                name: importDef.displayName,
                id: importDef.id
            }))
        },
        exchangeRateOptions() {
            return this.exchangeRates.map(exRate => ({name: exRate.systemName, id: exRate.id}))
        },
        selectedWidgetType() {
            return Widgets.find(widget => widget.name == this.value.widgetType);
        },
    },
    methods: {
        requestDelete() {
            this.$emit("deleteRequested")
        },
        operationQueryOptions(operationDefinitionId) {
            return this.operationQueries
              .filter(query => query.parameters.operationDefinition.value === operationDefinitionId)
              .map(query => ({id: query.id, name: query.name == null ? "No-name" : query.name}))
        },
    },

}
</script>

<style scoped>
.widget-actions {
    display: flex;
    flex-flow: row;
}

.handle {

}

.handle:hover {
    cursor: grab;
}
</style>